import  { useEffect, useReducer, useState } from "react";
import "./GlobalContactAutoNurtureContainer.css";
import GlobalContactFindNurtureInit from "./GlobalContactFindNurtureInit";
import DynamicStepper from "../../genericComponents/uiElements/DynamicStepper";
import { parseCSV, STEP_IDS } from "../../../../utilities/uiUtils";
import { useUser } from "../../../../context/UserContext";
import {
  createCampaign,
  nurtureContactSearchSave,
  nurtureContactSearchSaveFromGlobalContacts,
  userClientData,
} from "../../../../services/iqApiV2";
import NurtureCampaignEmailReachOutV2 from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignEmailReachOut/NurtureCampaignEmailReachOutV2";
import { formatDateToYMD } from "../../../../utilities/dateUtils";
import { useGlobalContactSearchState } from "../GlobalContactSearchStateContext";

const initialStepState = {
  [STEP_IDS.CAMPAIGN_INIT]: false,
  [STEP_IDS.EMAIL_REACHOUT]: false
};

function stepReducer(state, action) {
  switch (action.type) {
    case "MARK_COMPLETED":
      return { ...state, [action.payload]: true };
    case "RESET_STEP":
      return { ...state, [action.payload]: false };
    default:
      return state;
  }
}

function GlobalContactAutoNurtureContainer({ setNurtureSidecardOpen }) {
  const [completedSteps, dispatch] = useReducer(stepReducer, initialStepState);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [currentCampDetails, setCurrentCampDetails] = useState({
    campaignName: "",
    selectedProducts: [],
    emailGenerationCount: 1,
    startDate: new Date(),
    context: "",
    campaignId:null,
    productLink:""
  });

  const {
    domains,
    contactEmailStat,
    orgHeadCount,
    jobTitle,
    orgRevenue,
    orgJobTitles,
    seniorities,
    personLocations,
    organizationLocations,
    paginationData
  } = useGlobalContactSearchState();
  const [emails, setEmails] = useState([]);
  const [productList, setProductList] = useState([]);

  const { user } = useUser();

  const handleGenerateEmailsCallback = async () => {
    const dataObj = {
      title: currentCampDetails?.campaignName,
      start_date:formatDateToYMD(new Date(currentCampDetails?.startDate)) ,
      context: currentCampDetails?.context,
      time_gap: 5,
      user_id: user?.id,
      user_name: user?.firstname + " " + user?.lastname,
      user_email: user?.email,
      client: user?.company_name,
      account: "",
      products: currentCampDetails?.selectedProducts,
      campaignId: null,
      opportunity_id: null,
      page_type: "GLOBAL_CONTACTS",
      email_generation_count: currentCampDetails?.emailGenerationCount,
      page_link:currentCampDetails?.productLink
    };

    const resp = await createCampaign(dataObj);

    if (resp?.campaign_id) {
      const [min, max] = orgRevenue;
      const formattedJobTitles = jobTitle
        ? jobTitle.split(",").map((title) => title.trim())
        : [];
      const payload = {
        person_titles: formattedJobTitles,
        q_organization_job_titles: orgJobTitles ? orgJobTitles : [],
        person_locations: personLocations,
        person_seniorities: seniorities,
        organization_locations: organizationLocations,
        q_organization_domains_list: parseCSV(domains),
        contact_email_status: contactEmailStat,
        organization_num_employees_ranges: orgHeadCount,
        revenue_range: { min, max },
        paginationData:paginationData
      };

      const filteredData = Object.fromEntries(
        Object.entries(payload).filter(
          ([key, value]) =>
            value && (Array.isArray(value) ? value.length > 0 : true)
        )
      );

      const searchInit = await nurtureContactSearchSaveFromGlobalContacts(
        resp?.campaign_id,
        filteredData
      );
        const searchList = {
              currentStepId:  STEP_IDS.CONTACT,
                };
      
      
                await nurtureContactSearchSave(
                  resp?.campaign_id,
                  searchList
                ) 
      console.log("searchInit", searchInit);

      setCurrentCampDetails((prev)=>({
        ...prev,
        campaignId:resp?.campaign_id
      }))
    }
    console.log("createCampaign", resp?.campaign_id);

    dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CAMPAIGN_INIT });
    setCurrentStepIndex((prev) => prev + 1);
  };

  useEffect(() => {
    async function fetchClientData() {
      try {
        const userId = user?.id; // ensure this is set
        const clientName = user?.company_name;
        const currentRole = user?.role_key || "CLIENT"; // or get from auth

        if (!userId || !clientName) {
          console.warn("Missing userId or clientName");
          return;
        }

        const data = await userClientData(userId, clientName, currentRole);
        if (Array.isArray(data?.products)) {
          const seen = new Set();
          const productsFormatted = data.products
            .filter((item) => {
              if (seen.has(item?._id)) return false; // duplicate -> skip
              seen.add(item?._id);
              return true;
            })
            .map((item) => ({
              _id: item?._id,
              name: item?.product_name,
              description: item?.product_description,
            }));

          setProductList(productsFormatted);
        } else {
          console.warn("Unexpected product structure:", data);
          setProductList([]);
        }
      } catch (error) {
        console.error("Failed to fetch client data:", error);
      }
    }

    fetchClientData();
  }, []);

  const stepsConfig = [
    {
      id: STEP_IDS.CAMPAIGN_INIT,
      title: "Setup",
      component: (
        <div>
          <GlobalContactFindNurtureInit
            productList={productList}
            currentCampDetails={currentCampDetails}
            setCurrentCampDetails={setCurrentCampDetails}
            generateEmailsCallBack={handleGenerateEmailsCallback}
          />
        </div>
      ),
    },
    {
      id: STEP_IDS.EMAIL_REACHOUT,
      title: "Generate Emails",
      component: (
        <NurtureCampaignEmailReachOutV2
          stepDispatch={dispatch}
          stepId={STEP_IDS.EMAIL_REACHOUT}
          currentCampDetails={currentCampDetails}
          setCurrentStepIndex={setCurrentStepIndex}
          emails={emails}
          setEmails={setEmails}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          sideCardCloseFunc={setNurtureSidecardOpen}
          skipReview={true}
        />
      ),
    },
  ];
  return (
    <div className="globalContactAutoNurtureContainer">
      <DynamicStepper
        stepsConfig={stepsConfig}
        completedSteps={completedSteps}
        currentStepIndex={currentStepIndex}
        setCurrentStepIndex={setCurrentStepIndex}
        // compInitiating={compInitiating}
        campaignStartDate={formatDateToYMD(new Date(currentCampDetails?.startDate)) }
        today={formatDateToYMD(new Date())}
        campActive={currentCampDetails?.campActive}
      />
    </div>
  );
}

export default GlobalContactAutoNurtureContainer;
